// Tutorial quest tracker (dismissible) + the Trust tooltip the KOL track asks you to read.
import { useState } from "preact/hooks";
import { dispatch, hud, openApp, phoneOpen, playerLoc, world } from "../bridge";
import { ZONES } from "../../world/districts";
import { lang } from "../i18n";

/** One tap to get each tutorial quest moving: walk there, or open the right app. */
const GO: Record<string, { label: string; pcm: string; run(): void }> = {
  farm: { label: "🧭 Take me to the Farm", pcm: "🧭 Carry me go Farm", run: () => walkToZone("farm") },
  sleep: { label: "🧭 Take me home", pcm: "🧭 Carry me go house", run: () => walkToZone("home") },
  gm: { label: "🐦 Open Chirp", pcm: "🐦 Open Chirp", run: () => openApp("chirp") },
  follow: { label: "🐦 Open Chirp", pcm: "🐦 Open Chirp", run: () => openApp("chirp") },
  chirp: { label: "🐦 Open Chirp", pcm: "🐦 Open Chirp", run: () => openApp("chirp") },
  shill: { label: "🐦 Open Chirp", pcm: "🐦 Open Chirp", run: () => openApp("chirp") },
  buy: { label: "📈 Open Pumpr", pcm: "📈 Open Pumpr", run: () => openApp("pumpr") },
};

function walkToZone(id: string) {
  const z = ZONES.find((x) => x.id === id);
  if (z) world()?.walkTo(z.x, z.z + 1);
}

export function QuestTracker() {
  const h = hud.value;
  const [tip, setTip] = useState(false);
  if (!h?.quest || phoneOpen.value || playerLoc.value.driving) return null;
  return (
    <div class="quest">
      <div class="quest-head">
        <span class="muted small">
          Quest {h.questStep + 1}/{h.questTotal}
        </span>
        <button class="quest-x" aria-label="Dismiss tutorial" onClick={() => dispatch({ type: "TUTORIAL", action: "dismiss" })}>
          ×
        </button>
      </div>
      <div class="quest-text">{h.quest}</div>
      {h.questId && GO[h.questId] && (
        <button class="btn small quest-go" onClick={() => GO[h.questId!].run()}>
          {lang.value === "pcm" ? GO[h.questId].pcm : GO[h.questId].label}
        </button>
      )}
      {h.questId === "trust" && !tip && (
        <button class="btn" onClick={() => setTip(true)}>
          ℹ️ What is Trust?
        </button>
      )}
      {tip && (
        <div class="tip">
          <p>
            <b>Trust</b> (0-100) multiplies how much your followers listen. Clout = followers × (0.25 + 0.75 × trust).
          </p>
          <p>Shilling your own bags more than twice a day, dumping right after a shill, bad calls and rugs all cost trust. Honest calls, threads, and airdrops build it.</p>
          <button
            class="btn primary"
            onClick={() => {
              setTip(false);
              dispatch({ type: "TUTORIAL", action: "read_trust" });
            }}
          >
            Got it
          </button>
        </div>
      )}
    </div>
  );
}
